// @ts-nocheck
import Services from './Services';
import useImageRender from '../../../../../hooks/useImageRender';
import PropTypes from 'prop-types';
import { TripDetailedDayPropTypes, TenantSettingsPropTypes } from '../types';
import { serviceTypes as serviceTypesConstants } from '../../../../../constants/serviceTypes';
import {
  getCheckInDate,
  getCheckOutDate
} from '../../../../../utils/dateUtility';
import { useFlags } from 'launchdarkly-react-client-sdk';
import * as PhosphorIcons from '@phosphor-icons/react';
import './ServiceSection.css';

const ServiceComponent = {
  ACCO: Services.HotelService,
  ACTV: Services.ActivityService,
  CAR: Services.CarService,
  FLTS: Services.FlightService,
  REST: Services.RestaurantService,
  TRN: Services.TrainService,
  TRAN: Services.TransferService
};

const ServiceSection = ({
  servicetype,
  tripdetaileddayserviceid,
  servicefields,
  tenantsettings,
  tripid,
  tenantid,
  startdate,
  daynumber
}) => {
  const { itineraryNavigation } = useFlags();
  const { getImageUrl } = useImageRender({
    pathReference: 'detailedDayService',
    tripId: tripid,
    tenantId: tenantid
  });
  const iconref = servicetype?.iconref;
  const isAccommodation =
    servicetype?.code === serviceTypesConstants.ACCOMMODATION;
  let checkInDate = null;
  let checkOutDate = null;

  const iconExists = (iconName) => {
    return typeof PhosphorIcons[iconName] === 'object';
  };

  if (isAccommodation && itineraryNavigation) {
    const numberOfNights =
      servicefields.find((field) => field.key === 'NUMBEROFNIGHTS')
        ?.options?.[0]?.value || 1;
    checkInDate = getCheckInDate(startdate, daynumber);
    checkOutDate = getCheckOutDate(checkInDate, numberOfNights);
  }

  const fields = servicefields.reduce((acc, field) => {
    let values = field.options.map((opt) => opt.value);

    // If only one option, store it as a single value instead of an array
    // Only assign if the value is not empty to avoid rendering empty check marks
    values =
      values.length > 1
        ? values
        : values[0] && values[0].trim() !== ''
          ? values[0]
          : null;

    // Ensure 'MEALSINCLUDED' is always an array, but only if values exist
    if (field.key === 'MEALSINCLUDED') {
      if (
        values === null ||
        values === '' ||
        (Array.isArray(values) && values.length === 0)
      ) {
        values = null; // Empty array means no meals, won't render anything
      } else if (!Array.isArray(values)) {
        values = [values]; // Convert single value to array
      }
    }

    // Transform 'UPLOADIMAGES' field values to image URLs
    if (field.key === 'UPLOADIMAGES') {
      values = Array.isArray(values)
        ? values.map(getImageUrl).filter(Boolean)
        : values
          ? [getImageUrl(values)]
          : [];
    }

    // Transform 'CHECKINDATE' and 'CHECKOUTDATE' fields to dates
    if (field.key === 'CHECKINDATE' && isAccommodation && itineraryNavigation) {
      values = checkInDate;
    }
    if (
      field.key === 'CHECKOUTDATE' &&
      isAccommodation &&
      itineraryNavigation
    ) {
      values = checkOutDate;
    }

    acc[field.key] = values;
    return acc;
  }, {});

  const ServiceTypeIcon = iconExists(iconref) ? PhosphorIcons[iconref] : null;
  const icon = ServiceTypeIcon && (
    <div className={`service-section__icon service-section__icon-${iconref}`}>
      <ServiceTypeIcon size={32} />
    </div>
  );

  const Component = ServiceComponent[servicetype?.code];

  if (!Component) {
    console.error(
      `Service component not yet implemented for type: ${servicetype?.name}`
    );
    return null;
  }

  return (
    <Component
      key={tripdetaileddayserviceid}
      servicefields={fields}
      servicetype={servicetype}
      tripdetaileddayserviceid={tripdetaileddayserviceid}
      tenantsettings={tenantsettings}
      icon={icon}
    />
  );
};

ServiceSection.propTypes = {
  ...TripDetailedDayPropTypes,
  tenantsettings: TenantSettingsPropTypes,
  tripid: PropTypes.number,
  tenantid: PropTypes.number,
  startdate: PropTypes.string,
  daynumber: PropTypes.number
};

export default ServiceSection;
